export default __webpack_public_path__ + "static/RENDER COMP (567x1024)-3d526a8a7231ff1c2a25d33158ca18ac.mp4";